// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WAzP","toggle":"styles_toggle__3-AZj","preview":"styles_preview__3Teka"};